<template>
  <b-row>
    <!-- left align -->
    <b-col
        md="6"
        lg="4"
    >
      <b-card
          no-body
          class="box-shadow-6"
      >
        <div class="my-2">
          <feather-icon
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.right="'Após 30 dias você terá que fazer a autenticação novamente'"
              class="cursor-pointer position-absolute position-right-0 position-top-0 m-1"
              icon="AlertCircleIcon"
              size="35"
          />
          <b-card-title class="text-center">
            <b-badge
                v-if="isAuth"
                variant="success"
                class="mb-1"
            >
              Autenticado
            </b-badge>
            <h2 class="font-weight-bold">
              Bling
            </h2>
          </b-card-title>
          <div class="text-center mb-1">
            <logo-bling/>
          </div>
          <b-card-text class="font-small-3 mx-2">
            o Bling é o sistema de gestão online que descomplica o seu negócio.
          </b-card-text>
          <div class="d-flex justify-content-center">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                :variant="isAuth ? 'primary' : 'outline-primary'"
                class="full-width mx-2"
                @click="integrations()"
                :disabled="isAuth"
            >
              {{ isAuth ? 'Continuar' : 'Escolher' }}
            </b-button>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BButton, BCard, BCardText, BCardTitle, BCol, BRow, VBTooltip, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import LogoBling from '@/components/logos/LogoBling.vue'

import SettingsIntegrationsService from '@/views/apps/settings/integrations/settingIntegrations.service'

const settingIntegrationsService = new SettingsIntegrationsService()

export default {
  name: 'SettingsIntegrations',
  components: {
    LogoBling,
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BCardTitle,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      dataAuth: {
        code: '',
        state: '',
      },
      isAuth: false,
    }
  },
  async mounted() {
    const valid = await settingIntegrationsService.getIntegrationsVerifyByNome('bling')
    this.isAuth = valid
  },
  methods: {
    async integrations() {
      const data = await settingIntegrationsService.getSettingIntegrations()

      const viewAuth = window.open(data.url, '_blank', 'width=500,height=500,left=200,top=200')

      const timer = setInterval(() => {
        if (viewAuth.closed) {
          clearInterval(timer)
          return
        }
        try {
          const urlParams = new URL(viewAuth.location.href)
          if (urlParams.searchParams.has('code') || urlParams.searchParams.has('state')) {
            const code = urlParams.searchParams.get('code')
            const state = urlParams.searchParams.get('state')
            this.dataAuth = {
              code,
              state,
            }
            settingIntegrationsService.client.postBlingAuthGetToken(code)
            clearInterval(timer)
            viewAuth.close()
          }
        } catch (error) {
          console.warn(error)
        }
      }, 1000)

      viewAuth.focus()
    },
  },
}
</script>

<style scoped lang="scss">

</style>
